module.exports = __webpack_public_path__ + "img/title+@2x.26143337.png";